
export const LoginRedirect = {
  REDIRECT_URL_KEY: 'redirect_url'
};

export const LoginState = {
  EZLOGIN: 'ez_login',
  EZLOGIN_REDIRECT: 'ez_login_redirect'
}